const GradientButton = ({text, onClick}) => {
  return (
    <button className="w-full sm:inline-block sm:w-auto sm:px-[50px] py-[15px] bg-gradient-to-r from-[#1e93fd] to-[#3154c8] cursor-pointer text-[0.9em] text-white rounded-[50px] uppercase font-semibold border-none" onClick={onClick}>
        {text}
    </button>
  )
}

export default GradientButton;